import colors from 'vuetify/lib/util/colors'
import { DangerousState } from '../../enum'

const usedColors = {
  [DangerousState.DISTRACTION]: colors.red.base,
  [DangerousState.DISTRACTION_NO_ATTENTION]: colors.red.base,
  [DangerousState.DISTRACTION_NO_FACE]: colors.brown.base,
  [DangerousState.DROWSINESS]: colors.purple.base,
  [DangerousState.BELT_NOT_FASTEN]: colors.black,
  [DangerousState.CELLPHONE_USE]: colors.green.base,
  [DangerousState.EATING]: colors.blue.base,
  [DangerousState.SMOKING]: colors.grey.base,
  [DangerousState.CAMERA_SABOTAGE]: colors.orange.base
}

const _initGeoJson = (value, type) => {
  if (value.hasOwnProperty('coordinates') && value.hasOwnProperty('type')) {
    return Object.freeze({
      type: 'Feature',
      properties: {
        style: {
          color: usedColors[type],
          weight: 5,
          opacity: 1
        }
      },
      geometry: Object.freeze(value)
    })
  } else {
    return {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: []
      }
    }
  }
}

export class RouteAdditionalStatistics {
  constructor ({
    distraction_no_face = {}, distraction_no_attention = {}, drowsiness = {},
    belt_not_fasten = {}, cellphone_use = {}, eating = {}, smoking = {},
    camera_sabotage = {}
  } = {}) {
    this.distraction_no_attention = _initGeoJson(distraction_no_attention, DangerousState.DISTRACTION_NO_ATTENTION)
    this.distraction_no_face = _initGeoJson(distraction_no_face, DangerousState.DISTRACTION_NO_FACE)
    this.drowsiness = _initGeoJson(drowsiness, DangerousState.DROWSINESS)
    this.belt_not_fasten = _initGeoJson(belt_not_fasten, DangerousState.BELT_NOT_FASTEN)
    this.cellphone_use = _initGeoJson(cellphone_use, DangerousState.CELLPHONE_USE)
    this.eating = _initGeoJson(eating, DangerousState.EATING)
    this.smoking = _initGeoJson(smoking, DangerousState.SMOKING)
    this.camera_sabotage = _initGeoJson(camera_sabotage, DangerousState.CAMERA_SABOTAGE)
  }

  isEmpty () {
    return Object.keys(this).every(item => {
      return this[item].geometry.coordinates.length === 0
    })
  }

  values () {
    return Object.keys(this).map(item => ({
      key: item,
      value: this[item]
    }))
  }
}
